import { createAction, props } from '@ngrx/store';

export const dummyAction = createAction('dummy');

// LOAD WORKFLOW ACTIVITYs
export const loadWorkflowActivity = createAction(
  '[WORKFLOW] Load Work flow activity',
  props<{ id: number }>()
);
export const loadWorkflowActivitySuccess = createAction(
  '[WORKFLOW] Load Work flow activity Success',
  props<{ workflowActivity: any }>()
);
export const updateCommentToWorkflow = createAction(
  '[WORKFLOW] Update comment to work flow activityt',
  props<{ comment: any }>()
);
export const updateWorkflow = createAction(
  '[WORKFLOW] Update work flow activity',
  props<{ workflowActivity: any; generalText?: any; close?: () => void; msg?: { success?: string; error?: string }; }>()
);
export const updateWorkflowSuccess = createAction(
  '[WORKFLOW] Update work flow activity Success',
  props<{ workflowActivity: any }>()
);
export const updateWorkflowFailure = createAction(
  '[WORKFLOW] Update work flow activity Success',
  props<{ workflowActivity: any }>()
);
